// extracted by mini-css-extract-plugin
export default {"description":"TextConfirmationModal_description__6mNrz","input":"TextConfirmationModal_input__WTFAr"};